import { Controller } from "@hotwired/stimulus"

// Resets a turbo-frame when the offcanvas is hidden
export default class extends Controller {
  static values = {
    frame: String,
    src: String
  }

  connect() {
    this.boundReset = this.reset.bind(this)
    this.element.addEventListener('hidden.bs.offcanvas', this.boundReset)
  }

  disconnect() {
    if (this.boundReset) {
      this.element.removeEventListener('hidden.bs.offcanvas', this.boundReset)
    }
  }

  reset() {
    const frame = document.getElementById(this.frameValue)
    if (frame && this.srcValue) {
      // Reset the frame src to trigger a fresh load next time
      frame.src = this.srcValue
    }
  }
}

